import React from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { Location } from "@/types";

interface LocationSelectorProps {
    locations?: Location[];
    selectedLocation?: Location | null;
    onChange?: (location: Location | null) => void;
    isDetecting?: boolean;
    className?: string;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
    locations = [],
    selectedLocation,
    onChange,
    isDetecting = false,
    className = "",
}) => {
    const handleLocationChange = (value: string) => {
        if (value === "all" || value === "") {
            onChange?.(null);
            return;
        }

        const location = locations.find(
            (loc) =>
                loc.slug === value ||
                loc.id?.toString() === value ||
                loc.name?.toLowerCase() === value.toLowerCase(),
        );

        if (location) {
            onChange?.(location);
        }
    };

    const getSelectValue = () => {
        if (!selectedLocation) return "all";
        return (
            selectedLocation.slug ||
            selectedLocation.id?.toString() ||
            selectedLocation.name?.toLowerCase() ||
            "all"
        );
    };

    return (
        <section className={` md:py-3 flex justify-end ${className}`}>
            <div className="py-2 px-4 rounded-lg text-white">
                <div className="flex items-center space-x-2">
                    {isDetecting && (
                        <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                            <span>Mendeteksi lokasi...</span>
                        </div>
                    )}

                    <div className="flex items-center gap-4">
                        <Select
                            value={getSelectValue()}
                            onValueChange={handleLocationChange}
                        >
                            <SelectTrigger className="w-[180px] border-0 outline-0 text-black dark:text-white">
                                <SelectValue placeholder="Pilih Lokasi" />
                            </SelectTrigger>
                            <SelectContent className="bg-lg-background dark:bg-dr-background">
                                <SelectItem
                                    className="text-black dark:text-white"
                                    value="all"
                                >
                                    Semua Lokasi
                                </SelectItem>
                                {locations.map((location) => (
                                    <SelectItem
                                        key={location.id || location.name}
                                        className="text-black dark:text-white"
                                        value={
                                            location.slug ||
                                            location.id?.toString() ||
                                            location.name?.toLowerCase() ||
                                            ""
                                        }
                                    >
                                        {location.name}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationSelector;
